import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { LanguageConfig } from '@lib/i18n/utils';
import { BaseResponse } from '@shared/utils/interfaces';
import { Observable } from 'rxjs';

import { getLanguagesUrl } from './languages.constant';

@Injectable({
  providedIn: 'root',
})
export class LanguagesApiService {
  private readonly http = inject(HttpClient);

  getLanguages(): Observable<BaseResponse<LanguageConfig[]>> {
    return this.http.get<BaseResponse<LanguageConfig[]>>(getLanguagesUrl());
  }
}
